import React from 'react';
// import UserNav from './userNav';
// import UserConnect from './userConnect';

import { useParams, NavLink } from "react-router-dom";
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux"
import { URL_COURTJUS_BACK, cle_COURTJUS } from '../constants/sources.js';
import { USER_INIT } from '../constants/globals.js';
import { updateUser, insertUser } from '../actions/actions-types.js';
import ImageUpload from './imageUpload';


const UserViewUP = (props) => {

    const { userCJ } = useSelector(state => state);
    const dispatch = useDispatch();

    const { postId } = useParams();
    const [userFiche, setUserFiche] = useState([]);
    const [userPass, setUserPass] = useState({ verifPass: "", verifPass2: "" });
    const [userSave, setUserSave] = useState({ saved: false });
    const [showUpdateImg, setShowUpdateImg] = useState(false);
    // const [uploadStatus, setUploadStatus] = useState(null);
    const headers = new Headers();
    headers.append('cle', cle_COURTJUS);

    const handleUploadStatusUpdate = (fileName) => {
        //console.log(fileName);
        if (fileName != 'error') {
            setUserFiche(oldUser => { return { ...userFiche, uPhotoProfil: fileName }; });
            setShowUpdateImg(!showUpdateImg);
        }

    };

    let userN = 0;
    if (typeof (postId) === "undefined" || userCJ.uAdmin === 0 || userCJ.uNum < 1) { userN = userCJ.uNum } else { userN = postId };
    useEffect(() => {
        if (userN === 0) {
            setUserFiche(USER_INIT);
        } else {
            fetch(`${URL_COURTJUS_BACK}/users/${userN}`, {
                method: 'GET',
                headers: headers,
            })
                .then(response => response.json())
                .then(res => {
                    if (res === null) {
                        setUserFiche(USER_INIT);
                    } else {
                        setUserFiche(res[0]);
                    }
                });
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setUserPass({ verifPass: "", verifPass2: "" });
    }
        , []);


    let adminSecu = true;
    if (userCJ.uAdmin !== 0) { adminSecu = false };
    let persoSecu = true;
    if (userCJ.uAdmin !== 0 || userCJ.uNum === userFiche.uNum) { persoSecu = false };
    let prodSecu = true;
    if (userCJ.uAdmin !== 0 || userCJ.uProducteur !== 0) { prodSecu = false };
    let globalSecu = false;
    if (userCJ.uAdmin === 0 && userFiche.uNum < 1) { globalSecu = true };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUserFiche(oldUser => { return { ...userFiche, [name]: value, uMsg: "" }; });
        event.preventDefault();
    };

    const handleDownCB = (event) => {
        const { name, value } = event.target;
        let newValue = 0;
        value == 0 ? newValue = 1 : newValue = 0;
        setUserFiche(oldUser => { return { ...userFiche, [name]: newValue }; });
        event.preventDefault();
    };
    const handleUpCB = (event) => {
        // obligé de faire les modif en deux fois car la case à cochée ne s'actualisait (visuellement) qu'a l'action suivante !
        setUserFiche(oldUser => { return { ...userFiche, uMsg: "" }; });
    };
    const handleChangeCB = (event) => {
        // fonction pour ne pas que reacte identifie une erreur
    };

    const handleClickUpateImg = () => {
        setShowUpdateImg(!showUpdateImg);
        //setShowUpdateImg(showUpdateImg);
    }

    function checkEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        let errMsg = "";
        // if ((userPass.verifPass.length>0 && userPass.verifPass.length<8) || userFiche.uPass.length<8) {
        //     errMsg="Le mot de passe doit avoir plus de 8 caracteres !";
        // };
        // if (userPass.verifPass!==userPass.verifPass2) {
        //     errMsg="Les deux mots de passe ne sont pas identiques !";
        // };
        if (userFiche.uNom.length < 3) {
            errMsg = "Vous n'avez pas indiqué de nom !";
        };
        if (userFiche.uPrenom.length < 3) {
            errMsg = "Vous n'avez pas indiqué de prénom !";
        };
        if (userFiche.uTel.length < 10) {
            errMsg = "Vous n'avez pas indiqué de numéro de téléphone !";
        };
        if (!checkEmail(userFiche.uMail)) {
            errMsg = "L'adresse mail n'est pas valide !";
        };
        if (errMsg) {
            setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
        };
        fetch(`${URL_COURTJUS_BACK}/userverifexist/${userFiche.uMail}`, {
            method: 'GET',
            headers: headers,
        })
            .then(response => response.json())
            .then(res => {
                if (res != null) {
                    if (res[0].nb > 0 && res[0]._id.uNum !== userFiche.uNum) {
                        // si l'adresse existe déjà et que n'est pas la meme fiche utilisateur
                        errMsg = "Adresse mail déjà existante !"
                        setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                    } else {
                        if (!errMsg) {
                            if (userFiche.uNum === 0) {
                                // Ajout d'un utilisateur
                                dispatch(insertUser({ userFiche }))
                                errMsg = "Utilisateur Ajouté !"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                                setUserSave(oldUser => { return { ...userSave, saved: true }; });
                            } else {
                                // Modification d'un utilisateur
                                dispatch(updateUser({ userFiche }))
                                errMsg = "Informations mises à jour !"
                                setUserFiche(oldUser => { return { ...userFiche, uMsg: errMsg }; });
                            }

                        }
                    }
                }
            });


    };



    return (
        <main className="container">
            <div className="main-down"></div>
            {/* {userMenu===true && <UserNav />} */}
            {/* {userMenu===true && <UserConnect />} */}
            {globalSecu === false &&
                <>
                    <section className="section-prods section-prods-form">
                        <form method="POST" id="formContact" encType="multipart/form-data" disabled={persoSecu} onSubmit={handleSubmit}>
                            <img src={`/img/pictures/${userFiche.uPhotoProfil}`} alt="la vue de l'adherent" onClick={handleClickUpateImg} className="float-prods form-img zone-tel-masque" />
                            <article className="section-prods-fiche form-fiche">
                                <fieldset disabled={persoSecu}>
                                    <legend>infos contact <span className='span-light'>({userFiche.uNum})</span></legend>
                                    <p><label htmlFor="uNom">Nom</label> <input className="input-default" type="text" name="uNom" id="uNom" value={userFiche.uNom} required onChange={handleChange} /></p>
                                    <p><label htmlFor="uPrenom">Prénom</label> <input className="input-default" type="text" name="uPrenom" id="uPrenom" value={userFiche.uPrenom} required onChange={handleChange} /></p>
                                    <p><label htmlFor="uMail">Mail</label> <input disabled={adminSecu} className="input-default" type="email" name="uMail" id="uMail" value={userFiche.uMail} required onChange={handleChange} /></p>
                                    <p><label htmlFor="uTel">Téléphone</label> <input className="input-default" type="text" name="uTel" id="uTel" value={userFiche.uTel} required onChange={handleChange} /></p>
                                    <p>&nbsp;</p><p><NavLink to={`/userfichepw/${userFiche.uNum}`} title="Changer le mot de passe"><img src="/img/cadenas.png" alt="Changer le mot de passe" /></NavLink></p>
                                </fieldset>

                            </article>
                            <article className="section-prods-infos form-fiche">
                                <fieldset disabled={adminSecu}>
                                    <legend>Type contact</legend>
                                    <p>
                                        <label className="check" htmlFor="uActif"> Actif</label>
                                        <input type="checkbox" id="uActif" name="uActif" checked={userFiche.uActif === 1} value={userFiche.uActif} onMouseDown={handleDownCB} onMouseUp={handleUpCB} onChange={handleChangeCB} />
                                        <label className="check" htmlFor="uAdherent"> Adherent</label>
                                        <input type="checkbox" id="uAdherent" name="uAdherent" checked={userFiche.uAdherent === 1} value={userFiche.uAdherent} onMouseDown={handleDownCB} onMouseUp={handleUpCB} onChange={handleChangeCB} />
                                        <label className="check" htmlFor="uCommission"> Commission</label>
                                        <input type="checkbox" id="uCommission" name="uCommission" checked={userFiche.uCommission === 1} value={userFiche.uCommission} onMouseDown={handleDownCB} onMouseUp={handleUpCB} onChange={handleChangeCB} />
                                        <label className="check" htmlFor="uProducteur"> Producteur</label>
                                        <input type="checkbox" id="uProducteur" name="uProducteur" checked={userFiche.uProducteur === 1} value={userFiche.uProducteur} onMouseDown={handleDownCB} onMouseUp={handleUpCB} onChange={handleChangeCB} />
                                        <label className="check" htmlFor="uAdmin"> Admin</label>
                                        <input type="checkbox" id="uAdmin" name="uAdmin" checked={userFiche.uAdmin === 1} value={userFiche.uAdmin} onMouseDown={handleDownCB} onMouseUp={handleUpCB} onChange={handleChangeCB} />
                                    </p>


                                </fieldset>
                                {persoSecu === false &&
                                    <fieldset>
                                        <legend>Adresse</legend>
                                        <p><label htmlFor="uAdr_L1">Adresse</label> <input className="input-dbl" type="text" name="uAdr_L1" id="uAdr_L1" value={userFiche.uAdr_L1} onChange={handleChange} /></p>
                                        <p><label htmlFor="uAdr_L2">...</label> <input className="input-dbl" type="text" name="uAdr_L2" id="uAdr_L2" value={userFiche.uAdr_L2} onChange={handleChange} /></p>
                                        <p><label htmlFor="uAdr_L3">...</label> <input className="input-dbl" type="text" name="uAdr_L3" id="uAdr_L3" value={userFiche.uAdr_L3} onChange={handleChange} /></p>
                                        <p><label htmlFor="uAdr_CP">Code Postal</label> <input className="input-small" type="text" name="uAdr_CP" id="uAdr_CP" value={userFiche.uAdr_CP} onChange={handleChange} />
                                            <label htmlFor="uAdr_Ville"> Ville</label> <input className="input-default" type="text" name="uAdr_Ville" id="uAdr_Ville" value={userFiche.uAdr_Ville} onChange={handleChange} /></p>
                                    </fieldset>
                                }
                                {prodSecu === false &&
                                    <fieldset disabled={persoSecu}>
                                        <legend>infos comp. producteur</legend>
                                        <p><label htmlFor="uStructure">Entreprise</label> <input className="input-dbl" type="text" name="uStructure" id="uStructure" value={userFiche.uStructure} onChange={handleChange} /></p>
                                        <p><label htmlFor="uProduction">Productions</label> <input className="input-dbl" type="text" name="uProduction" id="uProduction" value={userFiche.uProduction} onChange={handleChange} /></p>
                                        <p><label htmlFor="uVente">lieu de Vente</label> <input className="input-dbl" type="text" name="uVente" id="uVente" value={userFiche.uVente} onChange={handleChange} /></p>
                                        <p><label htmlFor="uMailPro">Mail-Pro</label> <input className="input-dbl" type="email" name="uMailPro" id="uMailPro" value={userFiche.uMailPro} onChange={handleChange} /></p>
                                    </fieldset>
                                }
                                {prodSecu === false &&
                                    <fieldset disabled={adminSecu}>
                                        <legend>Référents</legend>
                                        <p><label htmlFor="uReferents">Noms</label> <input className="input-dbl" type="text" name="uReferents" id="uReferents" value={userFiche.uReferents} onChange={handleChange} /></p>
                                    </fieldset>
                                }
                                {/* <fieldset  disabled={persoSecu}>
                                    <legend>Photo carte de visite</legend>
                                    <p><input className="input-dbl" type="file" name="uPhotoProfil" id="uPhotoProfil" onChange={handleChange} /></p>
                                </fieldset> */}
                                {prodSecu === false &&
                                    <fieldset disabled={persoSecu}>
                                        <legend>Présentation</legend>
                                        <p><textarea className="input-area" name="uInfosComp" id="uInfosComp" onChange={handleChange} value={userFiche.uInfosComp}></textarea></p>
                                    </fieldset>
                                }
                                <fieldset disabled={persoSecu}>
                                    <legend>Sauvegarde</legend>
                                    {!userSave.saved &&
                                        <button id="fiche-sav" className='btn btn-primary'>Enregistrer</button>
                                    }
                                    <NavLink to={`/`} className="btn btn-secondary" title="Retour accueil">Retour</NavLink>
                                </fieldset>
                            </article>
                            <section className="nav-admin"><p className="section-prods-err">{userFiche.uMsg}</p></section>
                        </form>
                    </section>






                    {showUpdateImg &&
                        <div className='zone-fiche-fixed zone-fiche-fixed-small'>
                            <article>
                                <h2><NavLink aria-label="Retour Liste" title="Retour" onClick={handleClickUpateImg}><img className="btn-retour" src="/img/retour.png" alt="retour" /></NavLink></h2>
                            </article>
                            <article className="section-prods-infos form-fiche">
                                <fieldset>
                                    <legend>Photo de profil</legend>
                                    <div className={`form-zone`}>
                                        <ImageUpload userId={`u${userFiche.uNum}`} onUploadStatusUpdate={handleUploadStatusUpdate} />
                                    </div>
                                </fieldset>
                            </article>
                        </div>
                    }












                    <div className="main-down"></div>
                </>
            }
            {globalSecu &&
                <section className="section-prods"><p className="p-impact">Vous n'etes pas autorisé à acceder à ces informations</p></section>
            }
        </main>

    )
}

export default UserViewUP;